require.register("documenteditor/controllers/fieldEntryReadonlyCtrl", function(exports, require, module){
  $0
  
});

